<template>
    <div>
        <b-modal 
            id="tableModal" 
            ref="tableModal"
            :title="tableNameTranslatedPartStock" 
            size="lg" 
            :ok-only="true"
            :ok-variant="'secondary'"
            :ok-title="$t('misc.cancel')"
        >
            <data-table
                v-if="tableLoaded"
                :search="false"
                :exportable="false"
                :importable="true"
                :rows="getData.rowData"
                :columns="columnData"
                :perPage="perPage"
                :rowsCount="rowsCount"
                :currentPage="currentPage"
                :pageCount="pageCount"
                @changePage="changePage"
                @orderByEvent="orderByEvent"
                @rowClickDelete="onDeleteRow"
                @rowClickEdit="onEditRow"
                >
            </data-table>

            <b-btn class="btn btn-default mt-3 mr-2" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_stock'], ['create'])">
                <i class="fa fa-plus-circle mr-1"></i> {{$t('general.construction.material_management.procured.create_button')}}
            </b-btn>
        </b-modal>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="saveModal" id="saveModal" :title="actionTitle" size="md" @ok="saveAction" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_stock'], ['update']))">
            <div class="row mb-3">
                <div class="col-lg-4">
                    <label>{{ $t('table.status') }}</label>
                </div>
                <div class="col-lg-8">
                    <select v-model="model.status" class="form-control" size="1">
                        <option v-for="(status, key) in statuses" :value="key" :selected="key" :key="key">{{status}}</option>
                    </select>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-lg-4">
                    <label>{{ $t('table.quantity') }}</label>
                </div>
                <div class="col-lg-8">
                    <input type="number" onKeyPress="if(this.value.length==6) return false;" step=".01" class="form-control" v-model="model.quantity">
                </div>
            </div>
        </b-modal>

        <confirm-dialog ref="deleteModal" :title="actionDeleteTitle" @buttonClick="deleteAction">
            {{delete_message}}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import http from '@/libs/http';

import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';

export default {
    name: 'project_procured',
    components: {
        DataTable,
        ConfirmDialog,
        notificationIcons
    },
    data() {
        return {
            tableNameTranslatedPartStock: Vue.i18n.translate('general.construction.material_management.procured.title_modal'),
            actionTitle: '',
            actionDeleteTitle: '',
            delete_message: '',
            tableLoaded: false,
            row: null,
            perPage: 0,
            rowsCount: 0,
            pageCount: 0,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',

            getData: {
                rowData: []
            },
            model: {
                status: null,
                quantity: null,
                project_part_id: null,
            },
            columnData: [
                {
                    width: '90px',
                    label: Vue.i18n.translate('misc.actions'),
                    showDeleteButton: true,
                    showEditButton: true,
                },
                {
                    label: Vue.i18n.translate('table.status'),
                    field: 'statusV',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.quantity'),
                    field: 'quantity',
                    numeric: false,
                    html: false,
                }
            ]
        }
    },
    mounted () {
        http.route('storage?project_id='+this.$route.params.id).get().then(response => {
            if (response.data != false) {
                this.currentStorageNoSelect = true;
                this.currentStorage = response.data;
            }
        });
    },
    computed: {
        statuses: {
            get: function () {
                let statuses = {};
                let stats = this.$store.getters.getStockStatuses;
                if (typeof stats != 'undefined' && Object.keys(stats).length > 0) {
                    Object.keys(stats).forEach(key => {
                        if (key === 'procured') {
                            statuses[key] = stats[key];
                        }
                    });
                }

                return statuses;
            }
        }
    },
    watch: {
        statuses: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        showModal(id) {
            this.model.project_part_id = id;
            this.onLoadTable();
            this.$refs.tableModal.show();
        },
        hideModal() {
            this.$emit('onLoadTable');
            this.$refs.tableModal.hide();
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable() {
            http.route('project_stock?project_id=' + this.$route.params.id + '&project_part_id='+this.model.project_part_id + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType + '&filters[status]=procured').get().then(response => {
                if (!response.isError) {
                    this.perPage     = response.pagination.limit;
                    this.rowsCount   = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount   = response.pagination.totalPages;
                    var data         = response.data;

                    data.forEach(field => {
                        field.statusV = '';
                        if (field.status) {
                            field.statusV = this.statuses[field.status];
                        }
                    });

                    this.getData.rowData = data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslatedPartStock;
            this.row = null;
            this.model.status = null;
            this.model.quantity = null;
            this.$refs.saveModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslatedPartStock;
            this.row = row;
            this.model.status = this.row.status;
            this.model.quantity = this.row.quantity;
            this.$refs.saveModal.show();
        },
        saveAction (e) {
            e.preventDefault();

            let put_data = {
                project_id: this.$route.params.id,
                user_id: this.$store.state.user.user.id,
                quantity: this.model.quantity,
                status: this.model.status,
                project_part_id: this.model.project_part_id,
            };

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });
            
            if (this.row) {
                let data = http.route('project_stock/' + this.row.id).patch(put_data, true);
                data.then(response => {
                    if(response.isError == false) {
                        this.successMsg(this.tableNameTranslatedPartStock + Vue.i18n.translate('messages.updated'));
                        this.onLoadTable();
                        this.$emit('onLoadTable');
                        this.$refs.saveModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else {
                let data = http.route('project_stock').post(put_data, true);
                data.then(response => {
                    if(response.isError == false) {
                        this.successMsg(this.tableNameTranslatedPartStock + Vue.i18n.translate('messages.created'));
                        this.onLoadTable();
                        this.$emit('onLoadTable');
                        this.$refs.saveModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
        onDeleteRow (row, index) {
            this.actionDeleteTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslatedPartStock;
            this.delete_message = Vue.i18n.translate('messages.delete');
            this.row = row;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route('project_stock/' + this.row.id).delete();
                data.then(response => {
                    if (response.isError) {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    } else {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.$emit('onLoadTable');
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslatedPartStock + Vue.i18n.translate('messages.deleted'));
                        this.file = false;
                    }
                });
            }

            this.$refs.tableModal.show();
            this.$refs.deleteModal.hide();
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/construction/material_management/project_procured.vue